import { ApolloError } from '@apollo/client';

export const getGraphQlErrorMessage = (error: ApolloError): string => {
  const messages = error.graphQLErrors?.flatMap((graphQlError) => {
    const originalError = (
      graphQlError.extensions as {
        originalError?: { message?: string | string[] };
      }
    )?.originalError;

    if (Array.isArray(originalError?.message)) {
      return originalError?.message;
    }

    if (typeof originalError?.message === 'string') {
      return [originalError.message];
    }

    return graphQlError.message ? [graphQlError.message] : [];
  });

  return messages?.filter(Boolean).join('\n') || error.message;
};
